import {Component, OnInit} from '@angular/core';
import {ButtonSharedComponent} from "../components/buttons/button-shared/button-shared.component";
import {MatIcon} from "@angular/material/icon";
import {CommonModule} from "@angular/common";
import {BannerLogoComponent} from "../banner-logo/banner-logo.component";
import {BannerImageComponent} from "../banner-image/banner-image.component";
import {SeoService} from "../seo-service.service";

@Component({
    selector: 'app-contact-us',
  imports: [
    ButtonSharedComponent,
    CommonModule,
    MatIcon,
    BannerLogoComponent,
    BannerImageComponent,
  ],
    templateUrl: './contact-us.component.html',
    styleUrl: './contact-us.component.scss'
})
export class ContactUsComponent implements OnInit {

  constructor(private seo: SeoService) { }

  // for crawlers
  ngOnInit() {
    this.seo.updateMeta(
      "Contact Us | Sydney Advanced Endocrinology",
      "Find our clinic location, contact details, hours, parking, and transport information. Reach out to Sydney Advanced Endocrinology for appointments or enquiries."
    );
  }
}
